module.exports = __webpack_public_path__ + "static/media/google_06.56d9b3ff.svg";